import { OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LanguageSelectorService } from '../../services/language-selector/language-selector.service';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { Language } from '../../utils/language';

@Component({
  selector: 'app-overlay',
  standalone: true,
  imports: [OverlayModule, MaterialModule, PipesModule],
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.scss'
})
export class OverlayComponent implements OnInit {

	languages: any[] = [];
	@Output() dataSelected: EventEmitter<any> = new EventEmitter<any>();
	constructor(
		private languageService: LanguageSelectorService,
	) { }

	ngOnInit(): void {
		this.languageService.getLanguages().subscribe(data => {
			this.languages = data;
		  });
	}

	selectLanguage(language: Language){
		if (language) {
			this.dataSelected.emit(language);
		}
		this.cerrarOverlay();
	}

	cerrarOverlay() {
	}
}
